import { Language } from '@por/shared/core';

export const DEFAULT_LOCALE = Language.EN_US;

export const DEFAULT_CURRENCY = 'USD';

export const DEFAULT_GBP_CURRENCY = 'GBP';

export const MULTI_CONTRACT_MAX_SELECTION_ALLOWED = 50;

export const OFF_RENT_MAX_SELECTION_ALLOWED = 25;

export const INVOICE_MAX_SELECTION_ALLOWED = 50;

export const LOAD_MORE_DROP_DOWN_DEFAULT_VALUE = 25;

export const AVOID_LINE_ITEM_NAMES: string[] = ['insurance', 'collection', 'diesel', 'delivery', 'cc-fee', 'ach-fee'];

export const DEFAULT_PAYMENT_MID = '001';

/**
 * Default depot ID used when specific depot is not available.
 * Used for timezone display and other depot-specific operations.
 */
export const DEFAULT_DEPOT_ID = '001';

export const INVOICE_DUE_SOON_DAYS = 7;

/**
 * POR-Pay TransactionTypeEnum value for a TokenizeCard (vault-only) transaction (ADO-114949).
 * Mirrors PaymentAppTransactionType.TokenizeCard in the API lib.
 */
export const TOKENIZE_CARD_TRANSACTION_TYPE = 9;

/**
 * Minimum payment amount accepted online, in the contract's currency (ADO-119182).
 * A hard floor: RMS can return a payment-boundary MinimumCollectionAmount of 0, which must never
 * be honoured as an actual spendable minimum.
 */
export const MINIMUM_PAYMENT_AMOUNT = 1;
